import { ArrayCompositionPipeableArray } from '../base/pipeable/array_composition_pipeable_array.js';
import { ArrayCompositionPipeable } from '../base/pipeable/array_composition_pipeable.js';

class TripsPipeables {
  get plannedTrips() {
    if (!this.#plannedTrips) {
      this.#plannedTrips = new (class extends ArrayCompositionPipeableArray {
        static Sort = TripsPipeables.TripSort;
      })(
        this.#caster,
        () => this.#caster.plannedTrips,
        ['isPlanned'],
        `[Array:PlannedTrips]`
      );
    }
    return this.#plannedTrips;
  }

  get pastTripYears() {
    if (!this.#pastTripYears) {
      this.#pastTripYears =
        new (class PipeableYearsArray extends ArrayCompositionPipeableArray {
          static Sort = (a, b) => b - a;
        })(
          this.#caster,
          () => this.#caster.pastTripYears,
          ['isPlanned', 'year'],
          '[Array:PastTripYears]'
        );
    }
    return this.#pastTripYears;
  }

  getPastTrips(year) {
    let pipeable = this.#pastTrips.get(year);
    if (!pipeable) {
      pipeable = new (class extends ArrayCompositionPipeableArray {
        static Sort = TripsPipeables.TripSort;
      })(
        this.#caster,
        () => this.#caster.getPastTrips(year),
        ['isPlanned', 'year'],
        `Array:PastTrips${year}`
      );
      this.#pastTrips.set(year, pipeable);
    }
    return pipeable;
  }

  get hasTrips() {
    if (!this.#hasTrips) {
      (this.#hasTrips = new ArrayCompositionPipeable(this.#caster, () =>
        this.#caster.hasTrips()
      )),
        [],
        `[Value:HasTrips]`;
    }
    return this.#hasTrips;
  }

  static TripSort = (a, b) => {
    if (!a.startDate && b.startDate) {
      return 1;
    }
    if (!b.startDate && a.startDate) {
      return -1;
    }
    if (!a.startDate && !b.startDate) {
      return 0;
    }
    if (a.startDate > b.startDate) {
      return 1;
    }
    if (a.startDate < b.startDate) {
      return -1;
    }
    return a.duration - b.duration;
  };

  constructor(caster) {
    this.#caster = caster;
  }

  #caster;

  #hasTrips;
  #pastTrips = new Map();
  #pastTripYears;
  #plannedTrips;
}

export { TripsPipeables };
